import { elenaTestimonials, genericTestimonials } from '../../../mocks/testimonials';
import { Mentor } from '../../../mocks/mentors';

interface Props {
  mentor: Mentor;
}

const TestimonialsGrid = ({ mentor }: Props) => {
  const testimonials = mentor.id === 'elena-volkov' ? elenaTestimonials : genericTestimonials;

  return (
    <section className="bg-white rounded-2xl border border-slate-100 p-7">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-bold text-navy-800 text-base flex items-center gap-2">
          <i className="ri-chat-quote-line text-violet-500" />
          學員成功案例
          <span className="ml-1 px-2 py-0.5 bg-violet-100 text-violet-700 text-xs font-semibold rounded-full">
            {testimonials.length} 則
          </span>
        </h3>
        <div className="flex items-center gap-1">
          {[1, 2, 3, 4, 5].map((s) => (
            <i key={s} className="ri-star-fill text-amber-400 text-sm" />
          ))}
          <span className="text-sm font-bold text-navy-800 ml-1">{mentor.rating}</span>
          <span className="text-slate-400 text-xs ml-1">/ 5.0</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {testimonials.map((t) => (
          <div
            key={t.id}
            className="bg-slate-50 rounded-xl p-4 border border-slate-100 hover:border-violet-200 transition-colors"
          >
            <div className="flex items-start gap-3 mb-3">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-10 h-10 rounded-full object-cover object-top flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <div className="font-semibold text-navy-800 text-sm truncate">{t.name}</div>
                  <div className="flex items-center gap-0.5 ml-2 flex-shrink-0">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-amber-400 text-xs" />
                    ))}
                  </div>
                </div>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <span className="text-slate-500 text-xs">{t.role}</span>
                  <span className="text-slate-300 text-xs">@</span>
                  <span
                    className="text-xs font-semibold"
                    style={{ color: t.companyColor }}
                  >
                    {t.company}
                  </span>
                </div>
              </div>
            </div>

            <p className="text-slate-600 text-xs leading-relaxed mb-3 italic">
              &ldquo;{t.content}&rdquo;
            </p>

            <div className="flex items-center gap-3 pt-2.5 border-t border-slate-200">
              <div className="flex items-center gap-1">
                <i className="ri-trophy-fill text-amber-500 text-xs" />
                <span className="text-xs font-medium text-slate-700">{t.result}</span>
              </div>
            </div>
            {t.salary && (
              <div className="mt-1 flex items-center gap-1">
                <i className="ri-arrow-up-circle-fill text-green-500 text-xs" />
                <span className="text-xs text-green-700 font-medium">{t.salary}</span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-5 text-center">
        <div className="text-xs text-slate-400">
          已成功協助學員進入頂尖外商：
          {[
            { name: 'NVIDIA', color: '#76B900' },
            { name: 'Google', color: '#4285F4' },
            { name: 'Microsoft', color: '#00A4EF' },
            { name: 'Amazon', color: '#FF9900' },
            { name: 'Meta', color: '#0866FF' },
            { name: 'McKinsey', color: '#003580' },
          ].map((co, i) => (
            <span key={co.name}>
              <span className="font-semibold ml-1" style={{ color: co.color }}>
                {co.name}
              </span>
              {i < 5 && <span className="text-slate-300 ml-1">·</span>}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsGrid;
